import './FileUploaded.scss';

import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import Button, { ButtonStyle } from '@components/Button';
import { FileUploadStatus } from '@constants/file-upload-status';
import { IFileUploaded } from '@models/file';

interface IProps {
  file: IFileUploaded;
  readonly?: boolean;
  small?: boolean;
  onViewClicked?: () => void;
  onDeleteClicked?: () => void;
}

function FileUploaded({ file, onViewClicked, onDeleteClicked, readonly, small }: IProps) {
  const { t } = useTranslation();

  const className = classNames('modFileUploaded', {
    'modFileUploaded--readonly': readonly,
    'modFileUploaded--small': small,
  });
  const iconClassName = getIconClassNames(file);

  return (
    <div className={className}>
      <p className="modFileUploaded__name">
        {iconClassName && <i className={iconClassName} />} {file.name}
      </p>
      <div className="modFileUploaded__actions">
        {onViewClicked && (file.id || file.status === FileUploadStatus.Completed) && (
          <Button style={ButtonStyle.Action} onClick={onViewClicked}>
            {t('general.view')}
          </Button>
        )}
        {!readonly && (
          <span className="modFileUploaded__actions__danger">
            <Button style={ButtonStyle.Action} onClick={onDeleteClicked}>
              {file.status === FileUploadStatus.Uploading ? t('general.cancel') : t('general.delete')}
            </Button>
          </span>
        )}
      </div>
    </div>
  );
}

function getIconClassNames(file: IFileUploaded): string {
  switch (file.status) {
    case FileUploadStatus.Uploading:
      return 'modIcon modIcon--loader modIcon--is-spinning';
    case FileUploadStatus.Faulty:
      return 'modIcon modIcon--triangle-warning';
    default:
      if (file.type.match(/^image\//)) {
        return 'modIcon modIcon--taking-pictures-square';
      } else if (file.type.match(/pdf/)) {
        return 'modIcon modIcon--office-file-pdf';
      } else if (file.type.match(/dicom/)) {
        return 'modIcon modIcon--xray';
      } else if (file.type.match(/stl|obj/)) {
        return 'modIcon modIcon--design-document-3ds-1';
      } else {
        return undefined;
      }
  }
}

export default FileUploaded;
